// extracted by mini-css-extract-plugin
export default {"dashboard_container":"dashboard_container___YrdlS","scroll_bar":"scroll_bar___ynmND","category_badge":"category_badge___ByGxX"};